import React, { useState } from 'react';
import "../Login.css"
import "./Password.css"
import "./Email.css"
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import {Token, post} from "../../../Script/Session.js";
import { useNavigate } from 'react-router-dom';
import {setCookie, getCookie, cookieExists, deleteCookie} from "../../../Script/cookies.js";
import { getloginvalue } from '../../../Script/variables.js';
import { setEmail } from '../../../Script/variables.js';
const Email = () => {
    const navigate = useNavigate();
    const [aftercontentemail, setAfterContentemail] = useState("");
    const [afterContentpw, setAfterContentpw] = useState("");
    const [accwrong,setaccwrong] = useState("hidden");

    let elligalchars = false;
    const [buttonText, setButtonText] = useState('Code Senden');
    const changeinputtext = () => {
      setaccwrong("hidden");
      let us = document.getElementById("username");

      if (us.value.includes(">")||us.value.includes("<") || us.value.includes('"') || us.value.includes("'") || us.value.includes(" ") ||us.value.includes(":")){
        elligalchars = true
        us.style.borderColor =  "#ff0000";
        setAfterContentemail("Feld enthält ungültiges zeichen");
      }else {
        elligalchars = false
        us.style.borderColor =  "#ccc";
        setAfterContentemail("");
      }
    };
    const login = (e) => {
        e.preventDefault();
        if (elligalchars){
            document.getElementById("username").blur();
            return;
        }
        let us = document.getElementById("username").value;
        let body = {}
        body.email = us;
        let response = post(body, "/forgottpasswordauth");
        if (response != null) {
            setEmail(us);
            navigate("/forgottpw");
        }else {
            setaccwrong("visible");
        }


    }

    
    return (
        <div class="arounddev">
        <div class="login-container">
          <div className="email-header">
             <h1>Passwort vergessen</h1>
          </div>

            <label style={{ visibility: accwrong }} class="username-password-wrong-email">Falsche Email!</label>
            <form class="login-form" onSubmit={login}>
                <label class="login-label" for="username">Email</label>
                <div style={{ '--after-content': `"${aftercontentemail}"` }} id="emailerror" name="emailerror" class="login-after-div">
                    <input onChange={changeinputtext} class="login-input" type="text" id="username" name="username" ></input>
                </div>

                <button class="login-button" onClick={login} >
                    {buttonText}
                </button>
            </form>
        </div>
    </div>
    );

}
export default Email;